
import * as THREE from 'three';
import Phobject from './Phobject.js'

export default class Placard extends Phobject {
    constructor(linesOfText){
        super(false);
        let toM = function(n){
            return n/39.37;
        }
        this.dimPlacard = new THREE.Vector2(toM(10), toM(6)); //width, height
        this.group = new THREE.Group();

        // Table top
        var geoTop = new THREE.PlaneGeometry( this.dimPlacard.x, this.dimPlacard.y);
        var matPlacard = new THREE.MeshPhongMaterial( {color: 0xFFFFFF, side: THREE.DoubleSide});
        let meshCard = new THREE.Mesh( geoTop, matPlacard );

        this.height = .012;
        let margin = .02;
        let y = this.dimPlacard.y/2 - margin - this.height;
        let x = -this.dimPlacard.x/2 + margin;

        linesOfText.forEach((t)=>{
            this.createText(t,x,y );
            y-=this.height*1.5;
        });

        
        this.group.add(meshCard);
    }

    createText(t,x,y) {

        var fontLoader = new THREE.FontLoader();
        let font = fontLoader.parse(require('@/assets/fonts/hvfont1.json'))
        var textMaterial = new THREE.MeshPhongMaterial( { color: 0x000000 } );
        
        let fontStyle = {
            font: font,
            size: this.height,
            height: .001,
            curveSegments: 12,
            bevelEnabled: false,
            bevelThickness: 1,
            bevelSize: 4,
            bevelOffset: 0,
            bevelSegments: 5            
        };
        var geoBack = new THREE.TextGeometry( t, fontStyle);        
        var meshText = new THREE.Mesh( geoBack, textMaterial );
        meshText.position.y = y;
        meshText.position.x = x;
        this.group.add(meshText);
    }
      

    getObject(){
        return this.group;
    }

    setupPhysics(pos){
        this.group.position.copy(pos);
        // physics
        var options = {
            type:'box',
            size:[this.dimPlacard.x,this.dimPlacard.y, .01], 
            pos:[pos.x,pos.y,pos.z],
            density:.1,
            move:this.move
        }
    
        this.phobject = this.world.add( options );
    }
}
